import { FC } from 'react';

type Props = {
	className?: string;
};

const AgreementIcon: FC<Props> = ({ className }) => {
	return (
		<svg
			width='20'
			height='20'
			viewBox='0 0 20 20'
			xmlns='http://www.w3.org/2000/svg'
			fill='none'
			stroke='#EAEAEA'
			className={className}>
			<path
				d='M8.2666 18.0001C8.55448 18.0001 9.61926 17.5142 10.7061 16.5424M10.7061 16.5424C11.6329 15.7136 12.5757 14.5315 13.0667 12.9962C14.1333 9.66029 7.73326 12.9962 9.86662 15.7762C10.1291 16.1182 10.4118 16.3682 10.7061 16.5424ZM10.7061 16.5424C11.9883 17.3008 13.4915 16.6193 14.5099 15.8356C14.8212 15.5961 14.9768 15.4763 15.0697 15.5136C15.1627 15.5509 15.2169 15.7652 15.3256 16.1939C15.6732 17.5656 16.6999 18.6729 17.8667 16.8885'
				stroke='inherit'
				strokeWidth='1.25'
				strokeLinecap='round'
				strokeLinejoin='round'
			/>
			<path
				d='M17.0669 10.8001V6.71262C17.0669 5.34113 17.0669 4.65538 16.8525 4.10769C16.508 3.2272 15.7791 2.53269 14.8551 2.20428C14.2803 2 13.5607 2 12.1214 2C9.6027 2 8.34335 2 7.33752 2.35749C5.72053 2.93219 4.44505 4.14761 3.84195 5.68845C3.4668 6.64692 3.4668 7.84697 3.4668 10.2471V12.3088C3.4668 14.795 3.4668 16.0381 4.14496 16.9014C4.33927 17.1486 4.5697 17.3682 4.82927 17.5534C5.12294 17.7629 5.45851 17.9045 5.86682 18.0002'
				stroke='inherit'
				strokeWidth='1.25'
				strokeLinecap='round'
				strokeLinejoin='round'
			/>
			<path
				d='M3.4668 10.0001C3.4668 8.52727 4.66071 7.33339 6.13349 7.33339C6.66613 7.33339 7.29407 7.42672 7.81194 7.28796C8.27206 7.16466 8.63146 6.80526 8.75475 6.34513C8.89352 5.82727 8.80019 5.19933 8.80019 4.66669C8.80019 3.19392 9.99414 2 11.4669 2'
				stroke='inherit'
				strokeWidth='1.25'
				strokeLinecap='round'
				strokeLinejoin='round'
			/>
		</svg>
	);
};

export default AgreementIcon;
